import { useAppApi } from 'hooks/useAppApi';
import { createContext, useCallback, useContext } from 'react';

const PanelOperacionalContext = createContext(null);

export const PanelOperacionalProvider = ({ children }) => {
  const map = useCallback((result) => result, []);

  const { data, isLoading, error, hasCalled, call } = useAppApi({
    baseUrl: '/kpi/panel-operacional',
    mapResults: map,
  });

  return (
    <PanelOperacionalContext.Provider
      value={{ call, isLoading, error, hasCalled, data }}
    >
      {children}
    </PanelOperacionalContext.Provider>
  );
};

export const usePanelOperacional = () => useContext(PanelOperacionalContext);
